// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__yglJd","modalCard":"styles_modalCard__3CL6W","modalCard__message":"styles_modalCard__message__klVQH"};